import { getRequest } from 'helper/request';

const callback = document.querySelector('#upload-info')?.dataset?.callback;
const redirect = document.querySelector('#upload-info')?.dataset?.redirect;

const intervalId = window.setInterval(async () => {
  const data = await getRequest(callback);
  if (data.progress === 100) {
    window.clearInterval(intervalId);
    window.location.href = redirect;
  }
}, 1000);
